import React from 'react'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import useCsrfToken from '../hooks/useCsrfToken';

Blogfeatured.propTypes = {
    featured: PropTypes.number,
};

export default function Blogfeatured({ featured = '' }) {
    const { csrfToken } = useCsrfToken();
    const [listings, setListings] = useState([]);

    const API_URL = process.env.REACT_APP_API_URL;


    useEffect(() => {
        const transformData = (data) => {
            return data.map(item => ({
                id: item.id,
                image: `${API_URL}${item.primary_image}`,
                tag: 'Blog',
                title: item.title,
                slug: item.slug,
                desc: item.description.length > 100 ? item.description.substring(0, 100) + '...' : item.description,
            }));
        };
        if (csrfToken != null) {
            fetch(`${API_URL}/api/listings/blog/1/1`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => setListings(transformData(data)))
                .catch(error => console.error('Error fetching data:', error));
        }
    }, [API_URL, csrfToken]);
    return (
        <>
            <div className="row justify-content-center">
                {listings.slice(0, 6).map((item, index) => {
                    const stripTags = (html) => {
                        let doc = new DOMParser().parseFromString(html, 'text/html');
                        return doc.body.textContent || "";
                    };
                    return (
                        <div className="col-lg-4 col-md-6 col-12 mt-4 pt-2" key={index}>
                            <div className="blog position-relative overflow-hidden shadow rounded p-4 d-flex flex-column h-100">
                                <div className="position-relative">
                                    <div className="blog-image position-relative overflow-hidden rounded shadow object-fit-cover">
                                        <Link to={`/blog-leer/${item.slug}`}>
                                            <img src={item.image} className="img-fluid" alt="" />
                                        </Link>
                                    </div>

                                    <div className="position-absolute top-100 start-0 translate-middle-y ms-2">
                                        <Link to="#" className="badge bg-primary">{item.tag}</Link>
                                    </div>
                                </div>

                                <div className="pt-4 flex-grow-1 d-flex flex-column">
                                    <Link to={`/blog-leer/${item.slug}`} className="text-dark title h5">{item.title}</Link>

                                    <p className="text-muted my-2">{stripTags(item.desc)}</p>

                                    <Link to={`/blog-leer/${item.slug}`} className="text-dark read-more">Leer más <i className="mdi mdi-chevron-right align-middle"></i></Link>
                                </div>
                            </div>
                        </div>
                    )
                })}
            </div>
        </>
    )
}
